import { PostsTable } from '../components/posts/PostsTable'

export function PostsPage() {
  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-title">Posts</h1>
          <p className="page-subtitle">Manage, search, and publish your blog posts.</p>
        </div>
      </div>

      <div className="posts-page-body">
        <PostsTable />
      </div>

      <style>{`
        .posts-page-body {
          background: var(--bg-card);
          border: 1px solid var(--border);
          border-radius: var(--radius-lg);
          padding: 20px 24px;
        }
      `}</style>
    </>
  )
}
